
import { defineComponent, reactive } from 'vue'
import { Env } from '@loca/mfe-vue3'

export default defineComponent({
  name: 'Error500Page',
  setup() {
    const state = reactive({
      isInternational: Env.isInternational()
    })
    return {
      state
    }
  }
})
